import { FollowUp, PharmacySubmit } from '@brands/Dashboard/ConsultationPage/assets/types';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { IEducation } from './types/IEducation';
import { IOneReport } from './types/IOneReport';
import {
  IFulfillmentApprovalPayload,
  IPrescriptionOptoinal,
  ITreatmentsOptoinal,
  ObjectType,
} from './updateOneReportObject';

export const addOneReportObject = async (
  one_report_id: string,
  object_type: ObjectType,
  payload:
    | ITreatmentsOptoinal
    | IPrescriptionOptoinal
    | IEducation
    | FollowUp
    | PharmacySubmit
    | IFulfillmentApprovalPayload,
  userRole?: string,
): Promise<IOneReport> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<IOneReport>(`${prefix}/one_reports/${one_report_id}/${object_type}`, payload);

  return data;
};
